import { render, staticRenderFns } from "./AmetrasArticleInfoReplacementTemplate.vue?vue&type=template&id=11f1de51&scoped=true&"
import script from "./AmetrasArticleInfoReplacementTemplate.vue?vue&type=script&lang=ts&"
export * from "./AmetrasArticleInfoReplacementTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./AmetrasArticleInfoReplacementTemplate.vue?vue&type=style&index=0&id=11f1de51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f1de51",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCol,VDialog,VIcon,VRow,VSpacer,VToolbar,VToolbarTitle})
